// @ts-nocheck
import React from 'react'
import * as R from 'ramda'

import { Dropdown } from 'components/shared/Dropdown/Dropdown'
import CheckIcon from 'assets/icons/check-icon-dark.svg'

import styles from './LanguageSwitchMenu.module.scss'

export const LanguageSwitchMenu = ({
  language,
  languages,
  onSwitchLanguage,
}) => (
  <Dropdown.Menu className={styles.menu}>
    {R.map(
      ({ roundIcon, original, value }) => (
        <Dropdown.MenuItem className={styles.item} key={value}>
          <Dropdown.Action onClick={() => onSwitchLanguage({ code: value })}>
            <img className={styles.flag} src={roundIcon} alt={value} />
            <span className={styles.name}>{original}</span>
            {R.equals(language, value) ? (
              <img src={CheckIcon} alt={value} />
            ) : null}
          </Dropdown.Action>
        </Dropdown.MenuItem>
      ),
      languages,
    )}
  </Dropdown.Menu>
)